module.exports = parcelRequire.resolve("3RnMD");